class ToggleState {

	constructor(elemTrigger, a, b, lockBody=false){
		this.trigger  = document.querySelectorAll(`[data-trigger = "${elemTrigger}"]`);
		this.target   = document.querySelector(`[data-target     = "${elemTrigger}"]`);
		this.body     = document.querySelector(`body`);
		this.stateA   = a;
		this.stateB   = b;
		this.lockBody = lockBody;
		this._init();
	}

	_init(){
		for (let element of this.trigger) {
			element.addEventListener('click', ()=> {
				this.toggleState(this.stateA, this.stateB);
				if(this.lockBody){
					this.toggleBody('locked', 'unlocked');
				}
			});
		}
	}
		
	toggleState(one, two) {
		const newState = this.target.getAttribute('data-state') === one ? two : one;
  	this.target.setAttribute('data-state', newState);
	}

	toggleBody(one, two){
		const newState = this.body.getAttribute('data-state') === one ? two : one;
  	this.body.setAttribute('data-state', newState);
	}

}

export default ToggleState;